<template>
  <!-- Thin wrapper over PrimeVue Button, the design system's public API for buttons. Forwards every
       prop, event, and slot. Theming and defaults live in preset.js. Use this, not primevue/button. -->
  <Button v-bind="$attrs">
    <template
      v-for="(_, name) in $slots"
      #[name]="slotProps"
    >
      <slot
        :name="name"
        v-bind="slotProps"
      />
    </template>
  </Button>
</template>

<script setup>
import Button from 'primevue/button';

defineOptions({ inheritAttrs: false });
</script>
